
import { LucideIcon } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
interface MetricCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  description?: string;
  iconColor?: string;
}
export function MetricCard({
  title,
  value,
  icon: Icon,
  description,
  iconColor = "text-primary"
}: MetricCardProps) {
  return <Card className="rounded-sm bg-card">
      <CardContent className="p-6 rounded-sm">
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
          <Icon className={`h-5 w-5 ${iconColor}`} />
        </div>
        <div className="mt-4">
          <p className="text-2xl font-bold text-foreground">{value}</p>
          {description && <p className="text-xs text-muted-foreground mt-1">{description}</p>}
        </div>
      </CardContent>
    </Card>;
}
